import type { ContinuationTarget } from "~/helpers/pendingIntentLifecycle";
import type { ReceiverIdentityAdapter } from "~produce/production/helpers/continuationAdapter";

import isFilledString from "~/helpers/isFilledString";
import { HARDGOODS_INVENTORY_PATH } from "~produce/production/schedule/events/helpers/eventScheduleGrid";

export const HARDGOODS_INVENTORY_TARGET_KIND = "hardgoodsInventory";

export const HARDGOODS_INVENTORY_DOCK_PANEL_ID = "hardgoods";

export interface HardgoodsExactScope {
	materialItemIds: readonly [string, ...string[]];
	siteLocationId: string;
}

export const buildHardgoodsInventoryTarget = ({
	materialItemIds,
	siteLocationId
}: HardgoodsExactScope): ContinuationTarget => ({
	targetId: JSON.stringify({ materialItemIds: [...new Set(materialItemIds)], siteLocationId }),
	targetKind: HARDGOODS_INVENTORY_TARGET_KIND
});

const parseTargetId = (targetId: string): { materialItemIds?: unknown; siteLocationId?: unknown } | null => {
	try {
		return JSON.parse(targetId);
	} catch {
		return null;
	}
};

export const readHardgoodsExactScope = (target: ContinuationTarget | undefined): HardgoodsExactScope | null => {
	if (target?.targetKind !== HARDGOODS_INVENTORY_TARGET_KIND) return null;
	const scope = parseTargetId(target.targetId);
	const materialItemIds = scope?.materialItemIds;
	const siteLocationId = scope?.siteLocationId;
	if (!Array.isArray(materialItemIds) || materialItemIds.length === 0) return null;
	if (!materialItemIds.every(isFilledString) || !isFilledString(siteLocationId)) return null;
	return { materialItemIds: materialItemIds as [string, ...string[]], siteLocationId };
};

const hardgoodsInventoryReceiverIdentityAdapter: ReceiverIdentityAdapter = {
	buildCleanPath: (target) => (readHardgoodsExactScope(target) ? HARDGOODS_INVENTORY_PATH : ""),
	matchesRoute: () => null
};

export default hardgoodsInventoryReceiverIdentityAdapter;
